import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { DataService } from "../base-data-services/data.service";
import { SystemService } from "common/services/core-services/system.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { BatchListModel } from "common/models/page-models/Batches/batches-data-model";

 
@Injectable()
export class BatchListDataService extends DataService<BatchListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.batches_grid,http);
    }
 

   
    createInstance(): BatchListModel {
        return new BatchListModel();
    }

    
 
}